//@ts-check
import { Warehouse } from '@mui/icons-material';
import { Button, CircularProgress, Stack } from '@mui/material';
import { useRef, useState } from 'react';
import MBModal from '../../../../shared/components/modals/MBModal';
import ExpSnackbarAlerts from '../../../../shared/components/display/ExpSnackbarAlerts';
import { recalculateStock } from '../../services/StockRepository';
import { useReportingCoordination } from '../../../vessel/store';
import RHFStockRecalculationForm from './RHFStockRecalculationForm';

const StockRecalculationModal = ({
  isModalOpen,
  onClose = () => undefined,
}) => {
  const submitRef = useRef(null);
  const { fetchAllData } = useReportingCoordination();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const showSnackbar = (message, severity = 'success') =>
    setSnackbar({ open: true, message, severity });

  const handleSubmit = async (formData) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await recalculateStock(formData);
      showSnackbar('Stock recalculated successfully', 'success');
      fetchAllData();
      onClose();
    } catch (error) {
      console.error('Error recalculating stock:', error);
      showSnackbar(
        error?.message || 'Failed to recalculate stock. Please try again.',
        'error'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <MBModal
        titleIcon={<Warehouse fontSize='medium' />}
        fullWidth
        maxWidth='md'
        open={isModalOpen}
        onClose={onClose}
        disableClose={isSubmitting}
        title='Stock Recalculation'
        actions={
          <Stack direction='row' spacing={2} sx={{ padding: '20px 24px' }}>
            <Button
              variant='outlined'
              color='secondary'
              onClick={onClose}
              disableElevation
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button
              variant='contained'
              onClick={() =>
                submitRef.current && submitRef.current.requestSubmit()
              }
              disableElevation
              type='submit'
              disabled={isSubmitting}
              startIcon={
                isSubmitting ? (
                  <CircularProgress size={18} color='inherit' />
                ) : undefined
              }
            >
              Recalculate Stock
            </Button>
          </Stack>
        }
      >
        <RHFStockRecalculationForm onSubmit={handleSubmit} ref={submitRef} />
      </MBModal>
      <ExpSnackbarAlerts
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      />
    </>
  );
};

export default StockRecalculationModal;
